import rawGeoJson from '../greenland.json';

import { buildLayerAggregates, buildTeams, buildTimeline, buildZoneMetrics } from './aggregates';
import { DEFAULT_REGION_NAME, DEFAULT_SURVEY_DATE } from './constants';
import { computeMapMeta } from './map-meta';
import { normalizeFeature } from './normalizers';
import type { DashboardDataModel, PolygonFeature } from './types';

export function buildDashboardData(): DashboardDataModel {
  const rawFeatures = ((rawGeoJson as { features?: unknown[] }).features ?? []).map(normalizeFeature).filter(Boolean);
  const features = rawFeatures as PolygonFeature[];

  const layerAggregates = buildLayerAggregates(features);
  const regionName = features[0]?.properties.Region || DEFAULT_REGION_NAME;
  const surveyDate = features[0]?.properties.SurveyDate || DEFAULT_SURVEY_DATE;

  const realZoneAreaM2 = features.reduce((sum, feature) => sum + feature.properties.Shape_Area, 0);
  const realZoneShapeLengthKm = features.reduce((sum, feature) => sum + feature.properties.Shape_Leng, 0) / 1000;

  const zoneMetrics = buildZoneMetrics(realZoneAreaM2, realZoneShapeLengthKm, surveyDate);

  const totals = zoneMetrics.reduce(
    (acc, zone) => {
      acc.areaM2 += zone.areaM2;
      acc.shapeLengthKm += zone.shapeLengthKm;
      return acc;
    },
    { areaM2: 0, shapeLengthKm: 0 },
  );

  const teams = buildTeams(layerAggregates);
  const timeline = buildTimeline(layerAggregates, regionName);
  const mapMeta = computeMapMeta(features);

  return {
    featureCollection: {
      type: 'FeatureCollection',
      features,
    },
    layerAggregates,
    zoneMetrics,
    totals,
    teams,
    timeline,
    mapBounds: mapMeta.mapBounds,
    mapCenter: mapMeta.mapCenter,
    regionName,
  };
}
